import React, { useState, useEffect, useRef } from "react";
import Popup from "reactjs-popup";
import parseGoToDate from "./parseGoToDate";

var moment = require('moment');

const popupContentStyle = {
  border: "none",
  borderRadius: "12px",
  boxShadow: "0 20px 24px -4px rgba(10,13,18,0.08), 0 8px 8px -4px rgba(10,13,18,0.03), 0 3px 3px -1.5px rgba(10,13,18,0.04)",
  padding: "0px",
  background: "var(--od-surface, #fff)",
  width: "400px",
  maxWidth: "90vw",
};

const overlayStyle = {
  zIndex: "4000",
  backgroundColor: "rgba(10, 13, 18, 0.7)",
};

const GoToDateModal = ({
  isOpen,
  onClose,
  onGoToDate,
  currentDate,
}) => {
  const [dateValue, setDateValue] = useState("");
  const [parsedDate, setParsedDate] = useState(null);
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && currentDate) {
      const formatted = moment(currentDate).format('MMM D, YYYY');
      setDateValue(formatted);
      setParsedDate(currentDate);
      setError("");

      // Focus and select input after a short delay
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.select();
        }
      }, 50);
    }
  }, [isOpen, currentDate]);

  const parseDate = (value) => {
    if (!value.trim()) {
      setParsedDate(null);
      setError("");
      return;
    }

    const parsed = parseGoToDate(value);

    if (parsed) {
      setParsedDate(parsed);
      setError("");
    } else {
      setParsedDate(null);
      setError("Invalid date format");
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDateValue(value);
    parseDate(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && parsedDate) {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (parsedDate) {
        const newDate = moment(parsedDate).subtract(1, 'day').toDate();
        setParsedDate(newDate);
        setDateValue(moment(newDate).format('MMM D, YYYY'));
        setError("");
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (parsedDate) {
        const newDate = moment(parsedDate).add(1, 'day').toDate();
        setParsedDate(newDate);
        setDateValue(moment(newDate).format('MMM D, YYYY'));
        setError("");
      }
    }
  };

  const handleSubmit = () => {
    if (parsedDate) {
      onGoToDate(parsedDate);
      onClose();
    }
  };

  const handleCancel = () => {
    setDateValue("");
    setParsedDate(null);
    setError("");
    onClose();
  };

  return (
    <Popup
      open={isOpen}
      onClose={handleCancel}
      contentStyle={popupContentStyle}
      overlayStyle={overlayStyle}
      closeOnDocumentClick
      closeOnEscape
    >
      {_close => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <div style={{
            padding: "24px 24px 20px 24px",
          }}>
            <h2 style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "var(--od-c-333333, #333)",
              margin: "0",
            }}>
              Go to date
            </h2>
          </div>

          {/* Content */}
          <div style={{
            padding: "0 24px",
          }}>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}>
              <input
                ref={inputRef}
                type="text"
                value={dateValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder="Enter date (e.g., Jan 7, 2026)"
                style={{
                  padding: "10px 14px",
                  border: error ? "2px solid #f31b28" : "2px solid #2a9ce4",
                  borderRadius: "8px",
                  fontSize: "16px",
                  backgroundColor: "var(--od-c-ffffff, #fff)",
                  color: "var(--od-c-333333, #333)",
                  outline: "none",
                  boxShadow: "0 1px 2px rgba(10, 13, 18, 0.05)",
                }}
              />
              {error && (
                <span style={{ fontSize: "14px", color: "#f31b28" }}>
                  {error}
                </span>
              )}
              <span style={{ fontSize: "12px", color: "var(--od-c-717680, #717680)" }}>
                Use ↑/↓ arrows to adjust date, Enter to go
              </span>
            </div>
          </div>

          {/* Actions */}
          <div style={{
            padding: "32px 24px 24px 24px",
            display: "flex",
            gap: "12px",
          }}>
            <button
              onClick={handleCancel}
              style={{
                flex: 1,
                padding: "10px 16px",
                backgroundColor: "var(--od-c-ffffff, white)",
                border: "1px solid var(--od-c-d5d7da, #d5d7da)",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                color: "var(--od-c-414651, #414651)",
                cursor: "pointer",
                boxShadow: "0 1px 2px rgba(10, 13, 18, 0.05)",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={!parsedDate}
              style={{
                flex: 1,
                padding: "10px 16px",
                backgroundColor: parsedDate ? "var(--od-c-1982c4, #1982c4)" : "#a0c4dc",
                border: "2px solid rgba(255,255,255,0.12)",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                color: "white",
                cursor: parsedDate ? "pointer" : "not-allowed",
                boxShadow: "0 1px 2px rgba(10, 13, 18, 0.05)",
              }}
            >
              Go
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default GoToDateModal;
